module.exports = __webpack_public_path__ + "static/media/icon_cre.d1226fb6.svg";